"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FooterComponent = FooterComponent;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _useListBox3 = _interopRequireDefault(require("../../useListBox"));

var _PropsProvider = require("../../store/PropsProvider");

var _invokeOnChange = _interopRequireDefault(require("../../helpers/invokeOnChange"));

var sc = _interopRequireWildcard(require("./Footer.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function FooterComponent(props, ref) {
  var I18n = (0, _useI18n["default"])();

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      dispatch = _useListBox2[1];

  var providedProps = _react["default"].useContext(_PropsProvider.PropsContext);

  var labelCancel = props.labelCancel,
      labelAccept = props.labelAccept,
      labelClear = props.labelClear,
      isCancelVisible = props.isCancelVisible,
      isAcceptVisible = props.isAcceptVisible,
      isClearVisible = props.isClearVisible,
      kindAccept = props.kindAccept,
      kindCancel = props.kindCancel,
      kindClear = props.kindClear,
      renderExtraButton = props.renderExtraButton,
      size = props.size;

  var handleClickAccept = function handleClickAccept(event) {
    event.stopPropagation();
    dispatch({
      type: _useListBox3["default"].types.accept,
      payload: {
        onChangeFn: (0, _invokeOnChange["default"])(props.onClickAccept, "list-box:footer:accept")
      }
    });
  };

  var handleClickCancel = function handleClickCancel(event) {
    event.stopPropagation();
    var onChangeFn = props.onClickCancel ? (0, _invokeOnChange["default"])(props.onClickCancel, "list-box:footer:cancel") : (0, _invokeOnChange["default"])();
    dispatch({
      type: _useListBox3["default"].types.cancel,
      payload: {
        onChangeFn: onChangeFn
      }
    });
  };

  var handleClickClear = function handleClickClear(event) {
    event.stopPropagation();
    var onChangeFn = props.onClickClear ? (0, _invokeOnChange["default"])(props.onClickClear, "list-box:footer:clear") : (0, _invokeOnChange["default"])();
    dispatch({
      type: _useListBox3["default"].types.clear,
      payload: {
        isOpen: true,
        onChangeFn: onChangeFn
      }
    });
  };

  var isDisabled = props.isDisabled || providedProps.isDisabled;
  return /*#__PURE__*/_react["default"].createElement(sc.Footer, {
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("div", null, isAcceptVisible && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    isDisabled: isDisabled,
    kind: kindAccept,
    size: size,
    onClick: handleClickAccept
  }, labelAccept || I18n.t("listBox.footer.accept")), isCancelVisible && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    isDisabled: isDisabled,
    kind: kindCancel,
    size: size,
    onClick: handleClickCancel
  }, labelCancel || I18n.t("listBox.footer.cancel"))), /*#__PURE__*/_react["default"].createElement("div", null, isClearVisible && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    "data-pka-anchor": "footer-clear-button",
    isDisabled: isDisabled,
    kind: kindClear,
    size: size,
    onClick: handleClickClear
  }, labelClear || I18n.t("listBox.footer.clear")), renderExtraButton()));
}

var Footer = /*#__PURE__*/_react["default"].forwardRef(FooterComponent);

var propTypes = {
  /** If true it makes the accept button visible */
  isAcceptVisible: _propTypes["default"].bool,

  /** If true it makes the cancel button visible */
  isCancelVisible: _propTypes["default"].bool,

  /** If true it makes the clear button visible */
  isClearVisible: _propTypes["default"].bool,

  /** If true it makes the footer disabled */
  isDisabled: _propTypes["default"].bool,

  /** Sets what kind the accept button will be  */
  kindAccept: _propTypes["default"].oneOf([_button["default"].types.kind.PRIMARY, _button["default"].types.kind.MINOR]),

  /** Sets what kind the cancel button will be  */
  kindCancel: _propTypes["default"].oneOf([_button["default"].types.kind.PRIMARY, _button["default"].types.kind.MINOR]),

  /** Sets what kind the cancel button will be  */
  kindClear: _propTypes["default"].oneOf([_button["default"].types.kind.PRIMARY, _button["default"].types.kind.MINOR]),

  /** Sets the label for the accept button */
  labelAccept: _propTypes["default"].string,

  /** Sets the label for the cancel button */
  labelCancel: _propTypes["default"].string,

  /** Sets the label for the clear button */
  labelClear: _propTypes["default"].string,

  /** Callback to be executed when the accept button is clicked or activated by keyboard. */
  onClickAccept: _propTypes["default"].func,

  /** Callback to be executed when the cancel button is clicked or activated by keyboard. */
  onClickCancel: _propTypes["default"].func,

  /** Callback to be executed when the clear button is clicked or activated by keyboard. */
  onClickClear: _propTypes["default"].func,

  /** Render an extra button beside the clear button */
  renderExtraButton: _propTypes["default"].func,

  /** Determines the size of the footer */
  size: _propTypes["default"].oneOf([_button["default"].types.size.SMALL, _button["default"].types.size.MEDIUM, _button["default"].types.size.LARGE])
};
var defaultProps = {
  isAcceptVisible: true,
  isCancelVisible: true,
  isClearVisible: true,
  isDisabled: false,
  kindAccept: _button["default"].types.kind.PRIMARY,
  kindCancel: _button["default"].types.kind.MINOR,
  kindClear: _button["default"].types.kind.MINOR,
  labelAccept: null,
  labelCancel: null,
  labelClear: null,
  onClickAccept: null,
  onClickCancel: null,
  onClickClear: null,
  renderExtraButton: function renderExtraButton() {},
  size: _button["default"].types.size.MEDIUM
};
Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps; // forwardRef component are struggling with react-docgen
// https://github.com/pedronauck/docz/issues/334
// once we move to Storybook doc we might be able to remove this

FooterComponent.propTypes = propTypes;
FooterComponent.defaultProps = defaultProps;
Footer.displayName = "ListBox.Footer";
var _default = Footer;
exports["default"] = _default;
//# sourceMappingURL=Footer.js.map